import React from 'react';
import styled from 'styled-components';

import { reduxConnect } from '../../common';
import { utilities } from '@weatherbug/common';
/** @ts-expect-error - Ignoring Could not find a declaration file for module '@weatherbug/react' since don't have TS types for @weatherbug/react package... yet. */
import { IconWidget } from '@weatherbug/react';
import { DailyForecastSummaryBodyHeader } from './dailyForecastSummaryBodyHeader';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { IStdParameters, IStoreState } from '../common/interfaces/types';
import { AnimatedLoadingPlaceholder } from '../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { smallMediaQuery } from '../../common/utilities/sizeHelpers';

const { temperatureUnitAbbreviations } = utilities.units;

interface DailyForecastSummaryItemProps {
    authId: string;
    secret: string;
    forecastIndex: number;
    iconSize: string;
    resourceList: string;
    contentManagementBaseUrl: string;
    iconSet: string;
    stdParameters: IStdParameters;
    tempUnit: number;
    iconCode: number;
    isNightTimePeriod: boolean;
    detailedDescription: string;
    temperature: string;
    isLoadingForecast: boolean;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { units } =  storeState;
    const appState = storeState.appState.appState || {};
    const { authId, secret, forecastIconResourceList, forecastIconSize, forecastIconSet, contentMgmtBaseUrl, stdParameters } = appState;
    const { tempUnit } = units || {};

    return {
        tempUnit,
        authId,
        secret,
        stdParameters,
        iconSet: forecastIconSet,
        iconSize: forecastIconSize,
        contentManagementBaseUrl: contentMgmtBaseUrl,
        resourceList: forecastIconResourceList
    };
};

const mapDispatchToProps = {};

export const DailyForecastSummaryItem = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({
    tempUnit,
    authId,
    secret,
    stdParameters,
    iconSet,
    iconSize,
    contentManagementBaseUrl,
    iconCode,
    temperature,
    isNightTimePeriod,
    detailedDescription,
    isLoadingForecast,
    forecastIndex,
    resourceList }: DailyForecastSummaryItemProps) => {

    const userForecastSettings = temperatureUnitAbbreviations[tempUnit as keyof typeof temperatureUnitAbbreviations];

    const renderAnimatedLoadingUI = () => {
        return (
            <>
                <ForecastSummaryPeriodIcon>
                    <AnimatedLoadingPlaceholder height='100%' radius={30} />
                </ForecastSummaryPeriodIcon>
                <SummaryTextLoadingUI>
                    <AnimatedLoadingPlaceholder height='100%' radius={0} />
                </SummaryTextLoadingUI>
            </>
        );
    };

    return (
        <Container isNightTimePeriod={isNightTimePeriod}>
            <DailyForecastSummaryBodyHeader 
                forecastIndex={forecastIndex} 
                temperature={temperature}
                isNightTimePeriod={isNightTimePeriod}
                units={userForecastSettings}></DailyForecastSummaryBodyHeader>
            <ForecastSummaryPeriodBody>
                {
                    isLoadingForecast 
                        ? renderAnimatedLoadingUI()
                        :  <>
                            <ForecastSummaryPeriodIcon>
                                <LazyLoadComponent threshold={100} useIntersectionObserver={true}>
                                    <IconWidget iconCode={iconCode}
                                        iconSet={iconSet}
                                        iconSize={iconSize}
                                        authId={authId}
                                        secret={secret}
                                        contentManagementBaseUrl={contentManagementBaseUrl}
                                        stdParameters={stdParameters}
                                        resourceList={resourceList}>
                                    </IconWidget>
                                </LazyLoadComponent>
                            </ForecastSummaryPeriodIcon>
            
                            <ForecastSummaryPeriodDescription>
                                {detailedDescription}
                            </ForecastSummaryPeriodDescription>
                        </>
                }
            </ForecastSummaryPeriodBody>
        </Container>
    );
});

interface ContainerProps {
    isNightTimePeriod: boolean;
}

const Container = styled.div<ContainerProps>`
    height: 50%;
    display: flex;
    flex-direction: column;
    background-color: #F9F9F9;
    ${({ isNightTimePeriod }) => isNightTimePeriod && `
        background-color: #eee;
        border-bottom-right-radius: 2px;
        border-bottom-left-radius: 2px
    `}
`;

const ForecastSummaryPeriodBody = styled.div`
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    height: calc(100% - 38px);
    width: 100%;
    padding: 2px 10px;
`;

const ForecastSummaryPeriodIcon = styled.div`
    display: block;
    margin-right: 10px;
    padding-top: 3px;
    & .wb-content-mgt-icon-image {
        width: 60px;
        height: 60px;
        @media ${smallMediaQuery} {
            width: 57px;
            height: 57px;
        }
    }
`;

const ForecastSummaryPeriodDescription = styled.div`
    display: block;
    line-height: 1.3;
    line-clamp: 3;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    width: 100%;
    max-height: 60px;
    font-size: 14px;
`;

const SummaryTextLoadingUI = styled.div`
    display: flex;
    flex-direction: column;
    height: 60px;
    width: 100%;
`;
